/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terminology_Guide_OptionalInputs */



/**
* | output |
* | --- |
* | "KNP Terminology Guide (Optional)" |
*
* @param {Knp_Terminology_Guide_OptionalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terminology_guide_optional = /** @type {((inputs?: Knp_Terminology_Guide_OptionalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terminology_Guide_OptionalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guide de terminologie KNP (facultatif)")
	if (locale === "de") return /** @type {LocalizedString} */ ("KNP-Terminologieleitfaden (optional)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida alla terminologia KNP (facoltativa)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Справочник по терминологии КНП (необязательно)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía de terminología de KNP (opcional)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("KNP术语指南（可选）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNP用語ガイド（オプション）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केएनपी शब्दावली मार्गदर्शिका (वैकल्पिक)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guia de Terminologia do KNP (Opcional)")
	return /** @type {LocalizedString} */ ("KNP Terminology Guide (Optional)")
});